import React from 'react';
import PropTypes from 'prop-types';

/**
 * Error state component when image is not found
 */
const ImageNotFound = ({ imageId, index, page, images, matchParams }) => (
    <div className="p-8 text-center">
        <p className="text-red-600">Image not found</p>
        <p className="text-sm mt-2" style={{ color: 'var(--color-text)' }}>
            Image ID: {imageId || '(empty)'} | Index: {index} | Page: {page || 'home'}
        </p>
        {images?.length > 0 && (
            <p className="text-xs mt-2" style={{ color: 'var(--color-text)' }}>
                Available images: {images.slice(0, 5).join(', ')}
                {images.length > 5 ? '...' : ''}
            </p>
        )}
        <p className="text-xs mt-2" style={{ color: 'var(--color-text)' }}>
            Match params: {JSON.stringify(matchParams || {})}
        </p>
    </div>
);

ImageNotFound.propTypes = {
    imageId: PropTypes.string,
    index: PropTypes.number,
    page: PropTypes.string,
    images: PropTypes.array,
    matchParams: PropTypes.object,
};

export default ImageNotFound;
